import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Select(): Components {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreRoundedIcon
      },

      styleOverrides: {
        root: {}
      }
    }
  };
}
